import React, { Component, Fragment } from 'react';
import { CDBMain } from './CDBMain';
import ReactDOM from "react-dom";
import { Link } from 'react-router-dom';

interface SchoolMenuProps {
    prefix: string;
    prefixLink?: string;
    suffix?: string;
}

interface SchoolMenuState {

}

export default class SchoolMenu extends Component<SchoolMenuProps, SchoolMenuState> {

    static displayName = SchoolMenu.name;

    constructor(props: SchoolMenuProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {

    }

    async componentDidUpdate(prevProps: SchoolMenuProps, prevState: SchoolMenuState): Promise<void> {

    }

    private buildPagePrefix() {
        if (this.props.prefixLink) {
            return <Link to={this.props.prefixLink} className={"school-menu__page-prefix"} title={this.props.prefix}>
                {this.props.prefix}
            </Link>
        }
        else {
            return <div className={"school-menu__page-prefix"} title={this.props.prefix}>
                {this.props.prefix}
            </div>
        }
    }

    private buildPageSuffix() {
        if (this.props.suffix) {
            return <Fragment>
                <div className={"school-menu__page-splitter"}>
                    /
                </div>
                <div className={"school-menu__page-suffix"} title={this.props.suffix}>
                    {this.props.suffix}
                </div>
            </Fragment>
        }
    }

    render() {
        const contentStyleOverride = process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE ? { background: process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE } : {};
        const menu = (
            <Fragment>
                <div className="school-menu school-menu--top" style={contentStyleOverride}>
                    <div className="cdb-admin-content cdb-admin-content--column">
                        <div className={"school-menu__page"}>
                            {this.buildPagePrefix()}
                            {this.buildPageSuffix()}
                        </div>
                    </div>
                </div>
            </Fragment>
        );

        const parent = document.querySelector(`.${CDBMain.menuHeaderClass}`);
        if (parent) {
            return ReactDOM.createPortal(menu, parent!);
        }
        else {
            return null;
        }
    }
}